module.exports = __webpack_public_path__ + "img/currentTimeZh.7aadec08.png";